"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputLabel = require("./InputLabel.styled");
var InputLabel = exports.InputLabel = function InputLabel(_ref) {
  var labelFor = _ref["for"],
    children = _ref.children,
    description = _ref.description;
  return _react["default"].createElement(_InputLabel.StyledContainer, null, _react["default"].createElement(_InputLabel.StyledLabel, {
    "for": labelFor
  }, children), !!description ? _react["default"].createElement(_InputLabel.StyledDescription, {
    "data-testid": "styledDescription"
  }, description) : null);
};
InputLabel.defaultProps = {
  "for": '',
  description: ''
};
InputLabel.propTypes = {
  "for": _propTypes["default"].string,
  children: _propTypes["default"].string,
  description: _propTypes["default"].string
};
var _default = exports["default"] = InputLabel;